import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Box } from '../Box/Box.js';
import styled from 'styled-components';

var FloatingContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Container__FloatingContainer",
  componentId: "sc-1launur-0"
})(function (props) {
  return _defineProperty(_defineProperty(_defineProperty({
    opacity: 0
  }, "&.".concat(props.$visibleClass), {
    opacity: 1,
    transition: "opacity 0.3s ease-out ".concat(props.$fadeDelay, ", filter 0.3s ease-out ").concat(props.$fadeDelay),
    filter: 'drop-shadow(0 2px 7px rgba(0, 0, 0, 0.2))'
  }), "willChange", 'filter'), "transition", "opacity 0.3s ease-out ".concat(props.$fadeDelay, ", filter 0.3s ease-out ").concat(props.$fadeDelay));
});

export { FloatingContainer };
//# sourceMappingURL=Container.js.map
